import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./membershipConfirmation.scss";
import FundraiserHeader from "../common/FundraiserHeader";
import FundraiserBodyHeader from "../common/FundraiserBodyHeader";
import { Modal } from "antd";

import SwoodleModalLogo from "../../../Assets/Images/swoodleLogo.svg";
import GreenButton from "../../common/GreenButton";
import PrimaryOutlineButton from "../../common/PrimaryOutlineButton";
import PrimaryButton from "../../common/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../services/authService";
import { getFcmToken } from "../../../utils/connectStore";

const Confirmation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userRole = useSelector((state) => state?.authReducer?.tokenData?.user?.role);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const activateNow = () => {
    setIsModalOpen(true);
  };

  const activateLater = () => {
    setIsModalOpen(false);
  };

  const handleLogoutClick = async () => {
    // Store the user role before logout since it will be cleared
    const currentUserRole = userRole;
    
    const logoutPromise = await dispatch(
      logout({ fcmToken: getFcmToken() })
    )?.unwrap();
    if (logoutPromise?.success === "true") {
      // Redirect to fundraiser login page if user is a fundraiser, otherwise main login
      if (currentUserRole && currentUserRole.toLowerCase() === "fundraiser") {
        navigate("/fundraiser/account-login");
      } else {
        navigate("/");
      }
    }
  };

  const BodyHeaderContent = (
    <>
      You are about to activate your{" "}
      <span className="text-[#303030] font-[600]">
        {localStorage.getItem("fundraiserName") || "fundraiser"}{" "}
      </span>
      account with Swoodle. This will allow you to start fundraising and
      connecting with local businesses.
    </>
  );

  return (
    <>
      <FundraiserHeader />
      <div className="w-full flex flex-col items-center">
        <FundraiserBodyHeader
          heading={"Membership Confirmation"}
          content={BodyHeaderContent}
          contentClass={"w-[100%] sm:w-[80%] md:w-[90%]"}
        />

        <div className="w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%] xl:w-[45%] 2xl:w-[40%] mt-10 sm:mt-14">
          <div className="bg-[#F8F9FA] rounded-[10px] p-6 sm:p-8">
            <p className="font-poppins font-[400] text-[14px] sm:text-[16px] text-[#303030] mb-6">
              To complete your membership, you will need to activate your
              account. This process involves setting up your payment method and
              confirming your details.
            </p>
            <div className="flex flex-col sm:flex-row justify-between gap-4">
              <GreenButton
                label={"Activate Now"}
                className={
                  "w-full sm:w-[45%] h-[45px] sm:h-[50px] text-[14px] sm:text-[16px]"
                }
                onClick={activateNow}
              />
              <PrimaryOutlineButton
                label={"Activate Later"}
                className={
                  "w-full sm:w-[45%] h-[45px] sm:h-[50px] text-[14px] sm:text-[16px]"
                }
                onClick={activateLater}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        onCancel={activateLater}
        footer={null}
        centered
        width={340}
        className="fundraiser-logout-modal"
      >
        <div className="flex flex-col items-center p-6">
          <img
            src={SwoodleModalLogo}
            alt="Swoodle Logo"
            className="w-[120px] mb-4"
          />
          <p className="font-poppins font-[600] text-[16px] text-center mb-2">
            Confirm Logout
          </p>
          <p className="font-poppins font-[400] text-[14px] text-center text-[#767676] mb-6">
            Are you sure you want to logout?
          </p>
          <div className="flex gap-3 w-full">
            <PrimaryOutlineButton
              label={"No"}
              className={"flex-1 h-[40px] text-[14px]"}
              onClick={activateLater}
            />
            <PrimaryButton
              label={"Yes"}
              className={"flex-1 h-[40px] text-[14px]"}
              onClick={handleLogoutClick}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Confirmation;